




























import CommandForm from '@/components/Forms/CommandForm.vue'
import CommandTree from '@/components/CommandTreeComponent.vue'

import { Component, Vue } from 'vue-property-decorator'
import { Command } from '@/lib/Command'
import Yaml from '@/components/YamlComponent.vue'

@Component({
  components: {
    CommandForm,
    Yaml,
    CommandTree
  },
})
export default class Generator extends Vue {
  public showAddCommandForm = false;
  public TabId = '';

  get Commands() : Array<Command> {
    return this.$store.state.command.commands;
  }
}
